import {React, useEffect, useState} from 'react'
import {BiChevronDown} from 'react-icons/bi'

const BasicSelector = ({
    listItem ,
    children,
    border=true,
    // setOpenList,
    // openList,
    onSelected,
    label,
    defaultValue, 
    withArrow = true,
    withChangeLabel = true,
    size = 'sm',
    className,
    buttonClassName
    }) => {
    const [listLabel,setListLabel] = useState(label) 
    const [openList,setOpenList] = useState(false) 
    
    const customStyle = border
        ? 'bg-white border rounded px-3 py-1'
        : 'px-3 py-1'
    
    useEffect(() => {
        if (!defaultValue || !listItem) return;
        const matched = listItem.find((item) => item.value === defaultValue);
        if (matched && withChangeLabel) {
            setListLabel(matched.label);
        }
    }, [defaultValue, listItem, withChangeLabel]);

    useEffect(() => {
        if (label && label !== listLabel) {
            setListLabel(label);
        }
    }, [label, listLabel]);



    return (
        <div className={` relative flex flex-col px-3 ${className || ''}`}>
            <div 
                onClick={ ()=>  setOpenList(!openList)}
                className={`cursor-default ${size ==='lg' && 'h-8'} text-xs ${label && 'gap-1'} hover:font-bold flex items-center justify-between whitespace-nowrap ${customStyle} ${buttonClassName || ''}`} >
                { children} {label && listLabel}
                { withArrow && <BiChevronDown /> }
            </div>
            {
                listItem && 
                <ul 
                    className={`absolute w-full text-xs rounded-b-lg top-7 z-20 right-0 bg-white border border-slate-200 shadow ${openList && listItem.length > 1  ? 'block':'hidden'} `}>
                    {
                        listItem?.map((item,index) => (
                            <li 
                                onClick={
                                    () => {
                                        onSelected(item);
                                        setOpenList(false);
                                        setListLabel(item.label);
                                    }
                                }
                                key={index}
                                className={`cursor-default p-2 text-slate-700 hover:bg-slate-100 ${listItem.length > 0 && listItem.length !== index+1 && 'border-b'}`}
                                >
                                {item.label}
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    )
}

export default BasicSelector
